import {
  DeliveredWeeklyTwoByTwo,
  WeeklyTwoByTwo,
} from "@dimensional-engineering/dimensional-models";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type WeeklyTwoByTwoSlice = {
  latestChart: WeeklyTwoByTwo | null;
  deliveredForLatest: DeliveredWeeklyTwoByTwo | null;
  weeklyTwoByTwoLoaded: boolean;
};

const initialState: WeeklyTwoByTwoSlice = {
  latestChart: null,
  deliveredForLatest: null,
  weeklyTwoByTwoLoaded: false,
};

export const weeklyTwoByTwo = createSlice({
  name: "weeklyTwoByTwo",
  initialState: initialState,
  reducers: {
    setLatestWeeklyTwoByTwo: (
      state,
      action: PayloadAction<WeeklyTwoByTwo | null>
    ) => {
      return { ...state, latestChart: action.payload };
    },
    setDeliveredWeeklyTwoByTwo: (
      state,
      action: PayloadAction<DeliveredWeeklyTwoByTwo | null>
    ) => {
      return { ...state, deliveredForLatest: action.payload };
    },
    setWeeklyTwoByTwoLoaded: (state, action: PayloadAction<boolean>) => {
      return { ...state, weeklyTwoByTwoLoaded: action.payload };
    },
  },
});

export const {
  setLatestWeeklyTwoByTwo,
  setDeliveredWeeklyTwoByTwo,
  setWeeklyTwoByTwoLoaded,
} = weeklyTwoByTwo.actions;

export default weeklyTwoByTwo.reducer;
